import { Component } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { AppConstants } from '../../constant/app.constants';
@Component({
  selector: 'app-sidebar-header',
  templateUrl: './app-sidebar-header.component.html'
})
export class AppSidebarHeaderComponent {
  user_profile;
  user_profile_link;
  IMAGE_URL;
  constructor(private _router: Router) {
    let AuthUser = JSON.parse(localStorage.getItem('currentUser'));
    this.IMAGE_URL = AppConstants.IMAGE_URL;
    if (AuthUser) {
      this.user_profile = AuthUser;
      if (this.user_profile.roles[0].id == 3) {
        this.user_profile_link = '/installers/edit/' + this.user_profile.id;
      }
      else if (this.user_profile.roles[0].id == 4) {
        this.user_profile_link = '/distributors/edit/' + this.user_profile.id;
      }
      else if (this.user_profile.roles[0].id == 5) {
        this.user_profile_link = '/clients/edit/' + this.user_profile.id;
      } else {
        this.user_profile_link = '/users/edit/' + this.user_profile.id;
      }
    }
  }

}



// WEBPACK FOOTER //
// /var/www/midac/midac-live/app/src/app/components/app-sidebar-header/app-sidebar-header.component.ts